import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { baseUrl, Fetch } from "../../shared/Fetch";
import { IPermissionProps } from "../../models/Login";
import { IModal } from "../callingExtension";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Filter } from "../callingExtension/Filter";
import { Dialog } from "primereact/dialog";
import { format } from "date-fns";
import { Button } from "primereact/button";

export interface IExtensionCalling {
    extension_ID?: number,
    callerID?: string,
    ext_Destination?: string,
    displayName?: string,
    ivr_Company?: string,
    branch_Name?: string,
    noOfInbound?: number,
    noOfInB_ANSWERED?: number,
    noOfInB_BUSY?: number,
    noOfInB_FAILED?: number,
    noOfInB_NO_ANSWER?: number,
    noOfOutbound?: number,
    noOfOuB_ANSWERED?: number,
    noOfOuB_BUSY?: number,
    noOfOuB_FAILED?: number,
    noOfOuB_NO_ANSWER?: number,
};

export interface IExtensionCallingSub {
    id?: number,
    callDate?: Date,
    callerID?: string,
    extDestination?: string,
    billSec?: number,
    disposition?: string,
    callStatus?: string,
    extensionID?: string,
    extName?: string,
    callRecordFilename?: string,
}

export interface IFilter {
    fromDate?: Date,
    toDate?: Date,
    extension_ID?: number | null;
    callerID?: string | null;
    ext_Destination?: string | null;
    displayName?: string | null;
    ivR_Company?: string | null;
    branch_Name?: string | null;
}
export const EmptyFilter: IFilter = {
    fromDate: new Date(new Date().setDate(new Date().getDate() - 1)),
    toDate: new Date(new Date().setDate(new Date().getDate() - 1)),
    extension_ID: null,
    callerID: "",
    ext_Destination: "",
    displayName: "",
};

interface Iprops {
    setModal: (modal: IModal) => void;
    toast: any;
    reload: boolean;
    permissions: IPermissionProps;
    setReload: (is: boolean) => void;
}
export const UserCallingHistory = (props: Iprops) => {
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IExtensionCalling>, loading: boolean });
    const [subTableData, setSubTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IExtensionCallingSub>, loading: boolean });
    const [subTable, setSubTable] = useState({ singleData: {}, open: false } as { singleData: IExtensionCalling, open: boolean });
    const [showAudioModal, setShowAudioModal] = useState({ singleData: null, open: false } as { singleData: IExtensionCallingSub | null, open: boolean });
    const dt = useRef<any>(null);
    const [callFilter, setCallFilter] = useState<IFilter>(EmptyFilter);

    const loadTableData = async () => {
        setTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch(
            "Calling_Extension/getCallingHistory",
            "GET",
            null,
            `filter=${JSON.stringify(callFilter)}`,
            props.toast
        );
        if (response) {
            const data = await response.json();
            setTableData({ tableData: data, loading: false });
        }
    };

    //
    const loadSubTableData = async (data: { FromDate: Date, ToDate: Date, CallerID: string, CallStatus: string, Disposition: string }) => {
        setSubTableData({ tableData: tableData.tableData, loading: true });
        const response = await Fetch("Calling_Extension/getCallingHistorySubTable", "GET", null, `filter=${JSON.stringify(data)}`, props.toast);
        if (response) {
            const data = await response.json();
            setSubTableData({ tableData: data, loading: false });
        } else setSubTableData({ tableData: [], loading: false });
    };

    const callDate = (rowData: IExtensionCallingSub) => {
        let date;
        if (rowData.callDate) date = format(new Date(rowData.callDate), 'dd/MM/yyyy hh:mm a').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const LiveCallRecording = async (wavBlob: Blob) => {
        const formData = new FormData();
        formData.append("file", wavBlob);

        try {
            const response = await fetch(`${baseUrl}Calling_Extension/ConvertWavToMp3Upload`, {
                method: "POST",
                headers: {
                    Authorization: `Bearer ${JSON.parse(sessionStorage.getItem("auth") || '{}').token}`,
                },
                body: formData,
            });

            if (!response.ok) {
                throw new Error("Failed to convert WAV to MP3");
            }

            const blob = await response.blob();

            if (blob.type !== "audio/mpeg") {
                console.error("Invalid MP3 blob type:", blob.type);
                return;
            }

            const mp3Url = URL.createObjectURL(blob);
            console.log("Generated MP3 URL:", mp3Url);

            setShowAudioModal({
                singleData: {
                    callRecordFilename: mp3Url,
                },
                open: true,
            });

        } catch (error) {
            console.error("Error converting WAV to MP3:", error);
        }
    };

    const buttonForLiveDownloadCallRecording = (data: IExtensionCallingSub | any) => {
        const handleClick = async () => {
            try {
                const response = await fetch(`${baseUrl}Calling_Extension/DownloadWav?fileUrl=${encodeURIComponent(data.callRecordFilename)}`);
                //const blob = await response.blob();
                if (!response.ok) {
                    console.error("Failed to fetch .wav file");
                    return;
                }
                const wavBlob = await response.blob();
                LiveCallRecording(wavBlob); // pass blob to conversion function
            } catch (error) {
                console.error("Error fetching WAV file:", error);
            }
        };

        return (
            <Button
                icon="pi pi-play text-primary"
                className="p-button-rounded p-button-success p-button-text mr-1"
                onClick={handleClick}
            />
        );
    };

    useEffect(() => {
        loadTableData();
    }, [props.reload, callFilter]);

    const header = (
        <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center">
            <h5 className="m-0">User Calling History</h5>
        </div>
    );
    return (
        <>
            <Accordion>
                <AccordionTab header="Filter">
                    <Filter
                        callFilter={callFilter}
                        setCallFilter={(callFilter: any) => setCallFilter(callFilter)}
                        history={true}
                    />
                </AccordionTab>
            </Accordion>
            <DataTable
                style={{
                    border: "1px solid rgba(105,105,105,0.17)",
                    borderTopWidth: "0",
                }}
                ref={dt}
                size="small"
                showGridlines stripedRows responsiveLayout="scroll"
                scrollHeight="75vh"
                value={tableData.tableData}
                columnResizeMode="expand"
                emptyMessage="No History found."
                header={header}
                loading={tableData.loading}
            >
                <Column header="SN." body={(data, options) => options.rowIndex + 1} />
                <Column field="callerID" header="Caller ID" />
                <Column field="ext_Destination" header="Ext/ Designation" />
                <Column field="displayName" header="Display Name" />
                <Column field="ivR_Company" header="IVR Company" />
                <Column field="branch_Name" header="Branch" />
                <Column field="noOfInbound" header="#Inbound (IB)" body={(rowData: IExtensionCalling) => <p className={(rowData.noOfInbound !== undefined && rowData?.noOfInbound !== null && rowData?.noOfInbound > 0) ? "underline cursor-pointer text-cyan-700" : ""} onClick={() => {
                    if (rowData.noOfInbound !== undefined && rowData?.noOfInbound !== null && rowData?.noOfInbound > 0) {
                        loadSubTableData({ FromDate: callFilter.fromDate || new Date(), ToDate: callFilter.toDate || new Date(), CallerID: rowData.callerID || "", CallStatus: "Inbound", Disposition: "" });
                        setSubTable({ singleData: rowData, open: true });
                    }
                }}>{rowData.noOfInbound}</p>} />
                <Column field="noOfInB_ANSWERED" header="#IB Answered" body={(rowData: IExtensionCalling) => <p className={(rowData.noOfInB_ANSWERED !== undefined && rowData?.noOfInB_ANSWERED !== null && rowData?.noOfInB_ANSWERED > 0) ? "underline cursor-pointer text-cyan-700" : ""} onClick={() => {
                    if (rowData.noOfInB_ANSWERED !== undefined && rowData?.noOfInB_ANSWERED !== null && rowData?.noOfInB_ANSWERED > 0) {
                        loadSubTableData({ FromDate: callFilter.fromDate || new Date(), ToDate: callFilter.toDate || new Date(), CallerID: rowData.callerID || "", CallStatus: "Inbound", Disposition: "ANSWERED" });
                        setSubTable({ singleData: rowData, open: true });
                    }
                }}>{rowData.noOfInB_ANSWERED}</p>} />
                <Column field="noOfInB_BUSY" header="#IB Busy" body={(rowData: IExtensionCalling) => <p className={(rowData.noOfInB_BUSY !== undefined && rowData?.noOfInB_BUSY !== null && rowData?.noOfInB_BUSY > 0) ? "underline cursor-pointer text-cyan-700" : ""} onClick={() => {
                    if (rowData.noOfInB_BUSY !== undefined && rowData?.noOfInB_BUSY !== null && rowData?.noOfInB_BUSY > 0) {
                        loadSubTableData({ FromDate: callFilter.fromDate || new Date(), ToDate: callFilter.toDate || new Date(), CallerID: rowData.callerID || "", CallStatus: "Inbound", Disposition: "BUSY" });
                        setSubTable({ singleData: rowData, open: true });
                    }
                }}>{rowData.noOfInB_BUSY}</p>} />
                <Column field="noOfInB_FAILED" header="#IB Failed" body={(rowData: IExtensionCalling) => <p className={(rowData.noOfInB_FAILED !== undefined && rowData?.noOfInB_FAILED !== null && rowData?.noOfInB_FAILED > 0) ? "underline cursor-pointer text-cyan-700" : ""} onClick={() => {
                    if (rowData.noOfInB_FAILED !== undefined && rowData?.noOfInB_FAILED !== null && rowData?.noOfInB_FAILED > 0) {
                        loadSubTableData({ FromDate: callFilter.fromDate || new Date(), ToDate: callFilter.toDate || new Date(), CallerID: rowData.callerID || "", CallStatus: "Inbound", Disposition: "FAILED" });
                        setSubTable({ singleData: rowData, open: true });
                    }
                }}>{rowData.noOfInB_FAILED}</p>} />
                <Column field="noOfInB_NO_ANSWER" header="#IB No Answered" body={(rowData: IExtensionCalling) => <p className={(rowData.noOfInB_NO_ANSWER !== undefined && rowData?.noOfInB_NO_ANSWER !== null && rowData?.noOfInB_NO_ANSWER > 0) ? "underline cursor-pointer text-cyan-700" : ""} onClick={() => {
                    if (rowData.noOfInB_NO_ANSWER !== undefined && rowData?.noOfInB_NO_ANSWER !== null && rowData?.noOfInB_NO_ANSWER > 0) {
                        loadSubTableData({ FromDate: callFilter.fromDate || new Date(), ToDate: callFilter.toDate || new Date(), CallerID: rowData.callerID || "", CallStatus: "Inbound", Disposition: "NO ANSWER" });
                        setSubTable({ singleData: rowData, open: true });
                    }
                }}>{rowData.noOfInB_NO_ANSWER}</p>} />
                <Column field="noOfOutbound" header="#Outbound (OB)" body={(rowData: IExtensionCalling) => <p className={(rowData.noOfOutbound !== undefined && rowData?.noOfOutbound !== null && rowData?.noOfOutbound > 0) ? "underline cursor-pointer text-cyan-700" : ""} onClick={() => {
                    if (rowData.noOfOutbound !== undefined && rowData?.noOfOutbound !== null && rowData?.noOfOutbound > 0) {
                        loadSubTableData({ FromDate: callFilter.fromDate || new Date(), ToDate: callFilter.toDate || new Date(), CallerID: rowData.callerID || "", CallStatus: "Outbound", Disposition: "" });
                        setSubTable({ singleData: rowData, open: true });
                    }
                }}>{rowData.noOfOutbound}</p>} />
                <Column field="noOfOuB_ANSWERED" header="#OB Answered" body={(rowData: IExtensionCalling) => <p className={(rowData.noOfOuB_ANSWERED !== undefined && rowData?.noOfOuB_ANSWERED !== null && rowData?.noOfOuB_ANSWERED > 0) ? "underline cursor-pointer text-cyan-700" : ""} onClick={() => {
                    if (rowData.noOfOuB_ANSWERED !== undefined && rowData?.noOfOuB_ANSWERED !== null && rowData?.noOfOuB_ANSWERED > 0) {
                        loadSubTableData({ FromDate: callFilter.fromDate || new Date(), ToDate: callFilter.toDate || new Date(), CallerID: rowData.callerID || "", CallStatus: "Outbound", Disposition: "ANSWERED" });
                        setSubTable({ singleData: rowData, open: true });
                    }
                }}>{rowData.noOfOuB_ANSWERED}</p>} />
                <Column field="noOfOuB_BUSY" header="#OB Busy" body={(rowData: IExtensionCalling) => <p className={(rowData.noOfOuB_BUSY !== undefined && rowData?.noOfOuB_BUSY !== null && rowData?.noOfOuB_BUSY > 0) ? "underline cursor-pointer text-cyan-700" : ""} onClick={() => {
                    if (rowData.noOfOuB_BUSY !== undefined && rowData?.noOfOuB_BUSY !== null && rowData?.noOfOuB_BUSY > 0) {
                        loadSubTableData({ FromDate: callFilter.fromDate || new Date(), ToDate: callFilter.toDate || new Date(), CallerID: rowData.callerID || "", CallStatus: "Outbound", Disposition: "BUSY" });
                        setSubTable({ singleData: rowData, open: true });
                    }
                }}>{rowData.noOfOuB_BUSY}</p>} />
                <Column field="noOfOuB_FAILED" header="#OB Failed" body={(rowData: IExtensionCalling) => <p className={(rowData.noOfOuB_FAILED !== undefined && rowData?.noOfOuB_FAILED !== null && rowData?.noOfOuB_FAILED > 0) ? "underline cursor-pointer text-cyan-700" : ""} onClick={() => {
                    if (rowData.noOfOuB_FAILED !== undefined && rowData?.noOfOuB_FAILED !== null && rowData?.noOfOuB_FAILED > 0) {
                        loadSubTableData({ FromDate: callFilter.fromDate || new Date(), ToDate: callFilter.toDate || new Date(), CallerID: rowData.callerID || "", CallStatus: "Outbound", Disposition: "FAILED" });
                        setSubTable({ singleData: rowData, open: true });
                    }
                }}>{rowData.noOfOuB_FAILED}</p>} />
                <Column field="noOfOuB_NO_ANSWER" header="#OB No Answered" body={(rowData: IExtensionCalling) => <p className={(rowData.noOfOuB_NO_ANSWER !== undefined && rowData?.noOfOuB_NO_ANSWER !== null && rowData?.noOfOuB_NO_ANSWER > 0) ? "underline cursor-pointer text-cyan-700" : ""} onClick={() => {
                    if (rowData.noOfOuB_NO_ANSWER !== undefined && rowData?.noOfOuB_NO_ANSWER !== null && rowData?.noOfOuB_NO_ANSWER > 0) {
                        loadSubTableData({ FromDate: callFilter.fromDate || new Date(), ToDate: callFilter.toDate || new Date(), CallerID: rowData.callerID || "", CallStatus: "Outbound", Disposition: "NO ANSWER" });
                        setSubTable({ singleData: rowData, open: true });
                    }
                }}>{rowData.noOfOuB_NO_ANSWER}</p>} />
            </DataTable>
            <Dialog visible={subTable.open} style={{ width: '80vw' }} header={<p>User Calling History Details</p>} modal className="p-fluid" onHide={() => setSubTable({ singleData: {}, open: false })}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }} exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" scrollHeight="70vh"
                    value={subTableData.tableData}
                    loading={subTableData.loading}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="extName" header="Name" />
                    <Column field="callDate" header="Call Date" body={callDate} />
                    <Column field="extDestination" header="Destination" />
                    <Column field="billSec" header="Duration (Seconds)" />
                    <Column field="callStatus" header="Call Status" />
                    <Column field="disposition" header="Disposition" />
                    <Column header="Play Recording" body={buttonForLiveDownloadCallRecording} />
                </DataTable>
                {showAudioModal.open && (
                    <Dialog
                        header="Call Recording"
                        visible={showAudioModal.open}
                        style={{ width: '40vw' }}
                        onHide={() => setShowAudioModal({ open: false, singleData: null })}
                    >
                        <audio controls autoPlay style={{ width: '100%' }}>
                            <source src={showAudioModal?.singleData?.callRecordFilename} type="audio/mpeg" />
                            Your browser does not support the audio element.
                        </audio>
                    </Dialog>
                )}
            </Dialog>
        </>
    );
};